import React, { useEffect, useRef } from 'react'
import { PiXLight } from 'react-icons/pi'
import useGlobal from '../../Core/global'
const SendEmailModal = ({ itemId, onClose }) => {
  const { modalOpen, closeModal } = useGlobal()
  const handleClose = () => {
    closeModal(itemId)
    onClose()
  }

  const modalRef = useRef()
  useEffect(() => {
    const handleOutsideClick = event => {
      // Close modal if click is outside of modalRef
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal(itemId)
      }
    }

    // Add event listener when component mounts
    document.addEventListener('mousedown', handleOutsideClick)

    // Cleanup: Remove event listener when component unmounts
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])
  const handleChange = () => {}
  return (
    <div
      className={`${
        modalOpen[itemId] ? 'flex' : 'hidden'
      } w-full bg-black/20 h-screen fixed z-[10] top-0 left-0  items-center cursor-default justify-center`}
    >
      <div
        className='bg-white p-4 h-auto w-[400px] rounded-lg relative '
        ref={modalRef}
      >
        <div className='absolute right-[10px]'>
          <PiXLight
            size={30}
            className='cursor-pointer p-1 hover:bg-secondary/10 rounded-full'
            onClick={handleClose}
          />
        </div>
        <h1 className='text-[25px] '>Send Email</h1>
        <div>
          <form className='flex flex-col gap-2 w-full '>
            <div className='w-full flex flex-col gap-[3px]'>
              <p className='required text-dark '> Email title</p>
              <input
                type='text'
                name='email_title'
                placeholder='Email title'
                onChange={e => handleChange(e)}
              />
            </div>

            <div className='w-full flex flex-col gap-[3px]'>
              <p className='required text-dark'> Email body</p>
              <textarea
                type='text'
                name='email_body'
                placeholder='Email body'
                onChange={e => handleChange(e)}
                rows={4}
              ></textarea>
            </div>

            <div className='w-full flex flex-col gap-[3px] '>
              <p className='text-dark'>Email Attachment (optional)</p>
              <input
                type='file'
                multiple
                id='file-button'
                name='email_attachment'
                placeholder='Select Attachment'
                onChange={e => handleChange(e)}
              />
            </div>

            <button
              type='button'
              className='p-2 e w-[150px]  hover:bg-secondary/90  px-4 py-2 bg-secondary text-white mt-[20px]'
            >
              Send Email
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SendEmailModal
